function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Background--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--background--inject-10",
    d: "M446.07,138.72C351.75,12.9,216.48-13.53,99.57,68.85,3,136.88-5.26,289.61,31.94,358.81,59.7,410.44,133.8,469,230.78,480.64c115.78,13.95,167.81-13,206.23-45.46C510.36,373.13,507.58,220.78,446.07,138.72ZM145.19,465.85c-17.57-6.31-37.71-13.45-63.09-34.08a236.93,236.93,0,0,1-46.84-51.59c-7.28-11-11.3,35.9,30.59,68C116.28,486.84,162.85,472.19,145.19,465.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Numbers--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Binary--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.34,142l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,150.7a8.12,8.12,0,0,1-.52,3.09,3.54,3.54,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.28.47.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,168.77l1-.74V160.9l-1,.59v-.81L85.13,159v8.51l1-.37V168l-2.74,1.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,177.48a8.12,8.12,0,0,1-.52,3.09,3.54,3.54,0,0,1-1.44,1.81q-.91.52-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.28.47.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,195.55l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,208.94l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,222.33l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,231a8.14,8.14,0,0,1-.52,3.1,3.58,3.58,0,0,1-1.44,1.81q-.91.52-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.28.47.84.15a2,2,0,0,0,.84-1.12,6.07,6.07,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,249.11l1-.74v-7.13l-1,.59V241l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,257.81a8.14,8.14,0,0,1-.52,3.1,3.58,3.58,0,0,1-1.44,1.81q-.91.52-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.36-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.28.46.84.15a2,2,0,0,0,.84-1.12,6.07,6.07,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,275.89l1-.74V268l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83l-2.74,1.58Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.58,284.59a8.14,8.14,0,0,1-.52,3.1,3.58,3.58,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.36,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.51,3.51,0,0,0-.29-1.7c-.2-.3-.48-.35-.85-.13a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.79a3.34,3.34,0,0,0,.3,1.7q.28.46.84.15a2,2,0,0,0,.84-1.12,6.07,6.07,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,144.34a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8A1,1,0,0,1,71,149.1a4.23,4.23,0,0,1-.53-2.49v-2.25a8.16,8.16,0,0,1,.53-3.1,3.54,3.54,0,0,1,1.43-1.81c.61-.35,1.09-.3,1.45.15a4.21,4.21,0,0,1,.53,2.49Zm-.84-2.05a3.49,3.49,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.13a2,2,0,0,0-.83,1.1,5.86,5.86,0,0,0-.29,2v2.79a3.51,3.51,0,0,0,.29,1.7.55.55,0,0,0,.84.15,2,2,0,0,0,.84-1.12,5.86,5.86,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,162.41l1-.73v-7.13l-1,.58v-.8l1.81-1.65v8.52l1-.37v.82l-2.74,1.59Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,175.8l1-.73v-7.14l-1,.59v-.8l1.81-1.65v8.51l1-.36V175l-2.74,1.59Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,189.19l1-.73v-7.13l-1,.58v-.8l1.81-1.65V188l1-.37v.82L71.15,190Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,197.9a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.23,4.23,0,0,1-.53-2.49v-2.25a8.16,8.16,0,0,1,.53-3.1A3.54,3.54,0,0,1,72.42,193c.61-.35,1.09-.3,1.45.15a4.21,4.21,0,0,1,.53,2.49Zm-.84-2.05a3.49,3.49,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.13a2,2,0,0,0-.83,1.1,5.86,5.86,0,0,0-.29,2V200a3.51,3.51,0,0,0,.29,1.7.55.55,0,0,0,.84.15,2,2,0,0,0,.84-1.12,5.86,5.86,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,211.29a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.25,4.25,0,0,1-.53-2.49v-2.25a8.16,8.16,0,0,1,.53-3.1,3.54,3.54,0,0,1,1.43-1.81c.61-.35,1.09-.3,1.45.15A4.21,4.21,0,0,1,74.4,209Zm-.84-2a3.49,3.49,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.13a2,2,0,0,0-.83,1.1,5.86,5.86,0,0,0-.29,2v2.79a3.51,3.51,0,0,0,.29,1.7.55.55,0,0,0,.84.15,2,2,0,0,0,.84-1.12,5.88,5.88,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,229.36l1-.73v-7.14l-1,.59v-.8l1.81-1.65v8.51l1-.36v.82l-2.74,1.59Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,238.07a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.25,4.25,0,0,1-.53-2.49v-2.25A8.16,8.16,0,0,1,71,235a3.54,3.54,0,0,1,1.43-1.81,1,1,0,0,1,1.45.14,4.25,4.25,0,0,1,.53,2.49Zm-.84-2a3.49,3.49,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.13a2,2,0,0,0-.83,1.1,5.86,5.86,0,0,0-.29,2v2.79a3.51,3.51,0,0,0,.29,1.7c.2.31.48.36.84.14a2,2,0,0,0,.84-1.11,5.88,5.88,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,256.14l1-.73v-7.14l-1,.59v-.8l1.81-1.65v8.51l1-.36v.82L71.15,257Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,264.85a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.25,4.25,0,0,1-.53-2.49v-2.25a8.13,8.13,0,0,1,.53-3.1A3.54,3.54,0,0,1,72.42,260a1,1,0,0,1,1.45.14,4.25,4.25,0,0,1,.53,2.49Zm-.84-2.05a3.46,3.46,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.14a2.08,2.08,0,0,0-.83,1.11,5.86,5.86,0,0,0-.29,2v2.79a3.53,3.53,0,0,0,.29,1.7c.2.31.48.36.84.14a2,2,0,0,0,.84-1.11,5.88,5.88,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,282.92l1-.73v-7.14l-1,.59v-.8l1.81-1.65v8.51l1-.36v.82l-2.74,1.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,291.63a8.13,8.13,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.25,4.25,0,0,1-.53-2.49v-2.25a8.13,8.13,0,0,1,.53-3.1,3.54,3.54,0,0,1,1.43-1.81,1,1,0,0,1,1.45.14,4.25,4.25,0,0,1,.53,2.49Zm-.84-2.05a3.46,3.46,0,0,0-.29-1.69c-.19-.3-.48-.35-.85-.14a2,2,0,0,0-.83,1.11,5.82,5.82,0,0,0-.29,2v2.79a3.53,3.53,0,0,0,.29,1.7c.2.31.48.35.84.14a2,2,0,0,0,.84-1.11,5.88,5.88,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,305a8.16,8.16,0,0,1-.53,3.1,3.52,3.52,0,0,1-1.44,1.8,1,1,0,0,1-1.44-.14,4.25,4.25,0,0,1-.53-2.49V305a8.13,8.13,0,0,1,.53-3.1,3.54,3.54,0,0,1,1.43-1.81,1,1,0,0,1,1.45.14,4.25,4.25,0,0,1,.53,2.49Zm-.84-2a3.46,3.46,0,0,0-.29-1.69c-.19-.31-.48-.35-.85-.14a2,2,0,0,0-.83,1.11,5.82,5.82,0,0,0-.29,2v2.79a3.53,3.53,0,0,0,.29,1.7.55.55,0,0,0,.84.14,2,2,0,0,0,.84-1.11,5.88,5.88,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,156.06l1-.74v-7.13l-1,.59V148l1.81-1.64v8.51l1-.37v.83L59,156.88Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,169.45l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83L59,170.27Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,178.16a8.12,8.12,0,0,1-.52,3.09,3.59,3.59,0,0,1-1.44,1.81q-.91.52-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.29.47.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,196.23l1-.74v-7.13L59,189v-.81l1.81-1.64V195l1-.37v.83L59,197.05Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,204.94a8.08,8.08,0,0,1-.52,3.09,3.55,3.55,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48V205a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2.05a3.46,3.46,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6.07,6.07,0,0,0-.29,2V207a3.39,3.39,0,0,0,.3,1.7c.19.3.47.35.84.14a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,218.33a8.12,8.12,0,0,1-.52,3.09,3.59,3.59,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2.05a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.29.47.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,236.4l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83L59,237.22Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,245.1a8.14,8.14,0,0,1-.52,3.1A3.59,3.59,0,0,1,60.25,250q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.29.47.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,258.5a8.08,8.08,0,0,1-.52,3.09,3.59,3.59,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2.05a3.46,3.46,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6.07,6.07,0,0,0-.29,2v2.79a3.39,3.39,0,0,0,.3,1.7c.19.3.47.35.84.14a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,276.57l1-.74V268.7l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83L59,277.39Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,290l1-.74v-7.13l-1,.59v-.81l1.81-1.64v8.51l1-.37v.83L59,290.78Z",
    style: {
      fill: "#019E09",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,298.67a8.12,8.12,0,0,1-.52,3.09,3.59,3.59,0,0,1-1.44,1.81q-.91.53-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2.05a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.29.46.84.15a2,2,0,0,0,.84-1.12,6,6,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,316.74l1-.74v-7.13l-1,.59v-.81L60.76,307v8.51l1-.37V316L59,317.56Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,325.44a8.14,8.14,0,0,1-.52,3.1,3.59,3.59,0,0,1-1.44,1.81q-.91.52-1.44-.15a4.12,4.12,0,0,1-.53-2.48v-2.26a8.21,8.21,0,0,1,.52-3.1,3.52,3.52,0,0,1,1.44-1.8c.61-.35,1.09-.31,1.44.14a4.17,4.17,0,0,1,.53,2.49Zm-.83-2a3.43,3.43,0,0,0-.29-1.69c-.2-.31-.48-.35-.85-.14a2,2,0,0,0-.84,1.11,6,6,0,0,0-.29,2v2.8a3.32,3.32,0,0,0,.3,1.69q.29.46.84.15a2,2,0,0,0,.84-1.11,6.13,6.13,0,0,0,.29-2Z",
    style: {
      fill: "#019E09",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-code--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1,69.32V217.78a6.82,6.82,0,0,1-3.09,5.34l-105.6,60.93a2,2,0,0,1-1,.3,1.74,1.74,0,0,1-.39-.05,2.15,2.15,0,0,1-.27-.1l-.16-.09-.18-.12a1.22,1.22,0,0,1-.17-.15,2.33,2.33,0,0,1-.57-.81,3.91,3.91,0,0,1-.32-1.56V133.77a6.83,6.83,0,0,1,3.08-5.35L206,67.54a2.2,2.2,0,0,1,2.07-.26,1.17,1.17,0,0,1,.27.15l0,0a1,1,0,0,1,.2.2.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.59,1.59,0,0,1,.18.4.77.77,0,0,1,.08.27.07.07,0,0,1,0,.06,1.25,1.25,0,0,1,.05.29C209.09,69.06,209.1,69.19,209.1,69.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.38,68.12a.63.63,0,0,1,.3.07l0,0h0l.05,0,.09.11h0l.07.11,0,0,0,0,.1.29v0l0,0v0a.2.2,0,0,1,0,.07,2.83,2.83,0,0,1,0,.3V217.78a5.82,5.82,0,0,1-2.59,4.47L99.92,283.18a1,1,0,0,1-.52.17h0l-.21,0-.05,0h0l-.15-.1h0l0,0,0,0a1.5,1.5,0,0,1-.33-.48,2.91,2.91,0,0,1-.23-1.15V133.77a5.81,5.81,0,0,1,2.58-4.48l105.6-60.88a1.78,1.78,0,0,1,.87-.29m0-1a2.83,2.83,0,0,0-1.37.42l-105.6,60.88a6.83,6.83,0,0,0-3.08,5.35v147.7a3.91,3.91,0,0,0,.32,1.56,2.33,2.33,0,0,0,.57.81,1.22,1.22,0,0,0,.17.15l.18.12.16.09a2.15,2.15,0,0,0,.27.1,1.74,1.74,0,0,0,.39.05h0a1.92,1.92,0,0,0,1-.3L206,223.12a6.82,6.82,0,0,0,3.09-5.34V69.32c0-.13,0-.26,0-.38a1.25,1.25,0,0,0-.05-.29.07.07,0,0,0,0-.06.77.77,0,0,0-.08-.27,1.59,1.59,0,0,0-.18-.4.54.54,0,0,0-.1-.16.48.48,0,0,0-.09-.11,1,1,0,0,0-.2-.2l0,0a1.17,1.17,0,0,0-.27-.15,1.63,1.63,0,0,0-.7-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.1,69.32V217.78a6.82,6.82,0,0,1-3.09,5.34l-105.6,60.93a2,2,0,0,1-1,.3,1.74,1.74,0,0,1-.39-.05,2.15,2.15,0,0,1-.27-.1l-.16-.09-.18-.12a1.22,1.22,0,0,1-.17-.15,2.33,2.33,0,0,1-.57-.81,3.91,3.91,0,0,1-.32-1.56V133.77a6.83,6.83,0,0,1,3.08-5.35L206,67.54a2.2,2.2,0,0,1,2.07-.26,1.17,1.17,0,0,1,.27.15l0,0a1,1,0,0,1,.2.2.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.59,1.59,0,0,1,.18.4.77.77,0,0,1,.08.27.07.07,0,0,1,0,.06,1.25,1.25,0,0,1,.05.29C209.09,69.06,209.1,69.19,209.1,69.32Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,67.28a2.2,2.2,0,0,0-2.07.26l-105.6,60.88a6.83,6.83,0,0,0-3.08,5.35v10.07l-3.94-2.3v-10a6.81,6.81,0,0,1,3.08-5.33l105.6-60.89a2.17,2.17,0,0,1,2.24-.18C204.87,65.47,207.43,66.93,208.08,67.28Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.09,69.3c0-2-1.39-2.74-3.08-1.76l-105.6,60.89a6.81,6.81,0,0,0-3.08,5.33v10.09L209.09,79.42Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,67.54,100.42,128.42a6.41,6.41,0,0,0-2.18,2.29l-3.91-2.27a6.19,6.19,0,0,1,2.14-2.25l105.6-60.88a2.17,2.17,0,0,1,2.24-.18c.55.34,3.11,1.79,3.76,2.14A2.24,2.24,0,0,0,206,67.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.39,141.55v-10a6.3,6.3,0,0,1,.94-3.09l3.92,2.26a6.27,6.27,0,0,0-.92,3.07v10.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,80.78a4.58,4.58,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.6,4.6,0,0,0,1.74-3.69C192.26,81,191.48,80.22,190.52,80.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,77.15a4.61,4.61,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.58,4.58,0,0,0,1.74-3.68C198.53,77.35,197.75,76.6,196.79,77.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,73.52a4.61,4.61,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.68a4.61,4.61,0,0,0,1.74-3.69C204.8,73.72,204,73,203.06,73.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,284.06l-.38-.22-1-.54h0L96.6,283l0,0-.81-.47-.68-.38c-.18-.11-.32-.18-.38-.21a1.68,1.68,0,0,1-.53-.43,2.47,2.47,0,0,1-.42-.63,3.82,3.82,0,0,1-.35-1.62V141.54l3.94,2.3V281.47a4.63,4.63,0,0,0,.32,1.56,2.33,2.33,0,0,0,.57.81.5.5,0,0,0,.17.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9,152.22a1.15,1.15,0,0,1,.16-.57l2.22-4.59a.42.42,0,0,1,.1-.14l.05,0a.15.15,0,0,1,.18,0,.32.32,0,0,1,.07.23v1.54a1.6,1.6,0,0,1-.05.48,2,2,0,0,1-.15.42L106.31,152l1.17,1.07a.63.63,0,0,1,.15.24,1.16,1.16,0,0,1,.05.43v1.54a.7.7,0,0,1-.07.31.48.48,0,0,1-.18.21l-.05,0a.12.12,0,0,1-.1,0l-2.22-2a.46.46,0,0,1-.16-.4Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,140.72a2.07,2.07,0,0,1,.17-.45.8.8,0,0,1,.32-.36l.84-.48a.12.12,0,0,1,.17,0,.28.28,0,0,1,.07.22.56.56,0,0,1,0,.17l-3.8,16.2a2,2,0,0,1-.16.44.79.79,0,0,1-.33.37l-.8.46a.15.15,0,0,1-.18,0,.32.32,0,0,1-.07-.23,1.28,1.28,0,0,1,0-.17Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89,145.29a1.18,1.18,0,0,1-.16.57l-2.21,4.59a.64.64,0,0,1-.1.14l-.06,0a.12.12,0,0,1-.17,0,.28.28,0,0,1-.08-.22v-1.54a2,2,0,0,1,0-.48,2.06,2.06,0,0,1,.16-.42l1.17-2.42-1.17-1.08a.57.57,0,0,1-.16-.23,1.43,1.43,0,0,1,0-.43v-1.54a.71.71,0,0,1,.08-.31.46.46,0,0,1,.17-.21l.06,0a.13.13,0,0,1,.1,0l2.21,2a.45.45,0,0,1,.16.39Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05,144.22a.18.18,0,0,1,.22,0,.37.37,0,0,1,.09.27v1.7a.88.88,0,0,1-.09.38.49.49,0,0,1-.22.26l-1,.61a.17.17,0,0,1-.22,0,.37.37,0,0,1-.09-.27v-1.7a.88.88,0,0,1,.09-.38.53.53,0,0,1,.22-.26Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,142.2a.18.18,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.69a.85.85,0,0,1-.09.38.59.59,0,0,1-.22.26l-1,.61a.17.17,0,0,1-.22,0,.35.35,0,0,1-.09-.27v-1.7a.88.88,0,0,1,.09-.38.49.49,0,0,1,.22-.26Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,140.18a.17.17,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.69a.85.85,0,0,1-.09.38.61.61,0,0,1-.21.27l-1.05.6a.15.15,0,0,1-.21,0,.34.34,0,0,1-.09-.27v-1.7a.88.88,0,0,1,.09-.38.57.57,0,0,1,.21-.26Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,164.59l71.55-41.31c.6-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.81L105.84,167c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,105.84,164.59Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,183.58l71.55-41.31c.61-.35,1.1-.11,1.1.55a2.34,2.34,0,0,1-1.1,1.82L122.28,186c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,122.28,183.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,193.07l44.83-25.88c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-44.83,25.87c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,122.28,193.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,202.56l44.83-25.87c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-44.83,25.88c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,122.28,202.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,120.83,202.05,109c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82L181.64,123.2c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,181.64,120.83Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,258.92l53.92-31.23c.6-.35,1.1-.1,1.1.55a2.36,2.36,0,0,1-1.1,1.82L123.47,261.3c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,123.47,258.92Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,225.24l20.41-11.83c.61-.35,1.1-.11,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-20.41,11.83c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,181.64,225.24Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,225l69.37-40c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-69.37,40c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,132.68,225Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.28,244.85l86.77-50.38c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-86.77,50.38c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,115.28,244.85Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,251.83l58-33.62c.6-.35,1.1-.1,1.1.55a2.36,2.36,0,0,1-1.1,1.82l-58,33.62c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,119.36,251.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.28,235l11.47-6.63c.6-.34,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-11.47,6.62c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,115.28,235Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,174.11l50.2-29c.6-.35,1.09-.1,1.09.56a2.33,2.33,0,0,1-1.09,1.81l-50.2,29c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,105.84,174.11Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,174.11l50.2-29c.6-.35,1.09-.1,1.09.56a2.33,2.33,0,0,1-1.09,1.81l-50.2,29c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,105.84,174.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,183.58,116,177.72c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82L105.84,186c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,105.84,183.58Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,183.58,116,177.72c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82L105.84,186c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,105.84,183.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,193.07,116,187.21c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,105.84,193.07Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,193.07,116,187.21c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,105.84,193.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,202.57,116,196.7c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,105.84,202.57Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,202.57,116,196.7c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,105.84,202.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,212.06,116,206.2c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,105.84,212.06Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,212.06,116,206.2c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,105.84,212.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28,142.66l13-7.48c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.28,142.66Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.28,142.66l13-7.48c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,160.28,142.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.5,212.42l63.31-36.49c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82L121.5,214.8c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,121.5,212.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.84,231.19l96.21-55.69c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-96.21,55.69c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,105.84,231.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05,173.47l13-7.48c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-13,7.48c-.6.35-1.09.1-1.09-.56A2.37,2.37,0,0,1,189.05,173.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,174.09l50.2-29c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-50.2,29c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,122.28,174.09Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,174.09l50.2-29c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-50.2,29c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,122.28,174.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,142.64l13-7.48c.6-.35,1.1-.1,1.1.56a2.38,2.38,0,0,1-1.1,1.82l-13,7.48c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,176.72,142.64Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,142.64l13-7.48c.6-.35,1.1-.1,1.1.56a2.38,2.38,0,0,1-1.1,1.82l-13,7.48c-.6.34-1.09.1-1.09-.56A2.37,2.37,0,0,1,176.72,142.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Alert--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.61,283.25l-18.72-32.42a10.13,10.13,0,0,0-3.61-4c-.7-.39-3.5-2-4.23-2.45-2.91-1.65-5.89.06-7.61,5L71.05,317c-1.34,3.86-1,6.41.7,7.32.72.39,3.44,2,4.13,2.39,1.36.85,3.68.51,6.71-1.23l41.07-23.71A13.55,13.55,0,0,0,128.61,283.25Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.61,283.25l-18.72-32.42a10.13,10.13,0,0,0-3.61-4c-.7-.39-3.5-2-4.23-2.45-2.91-1.65-5.89.06-7.61,5L71.05,317c-1.34,3.86-1,6.41.7,7.32.72.39,3.44,2,4.13,2.39,1.36.85,3.68.51,6.71-1.23l41.07-23.71A13.55,13.55,0,0,0,128.61,283.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,251.9l-23.4,67.53c-2.44,7.07.82,9.77,7.3,6l41.07-23.71a13.55,13.55,0,0,0,5-18.5l-18.72-32.42C106.15,244.35,101.14,244.83,98.69,251.9Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55,292.7l-3.35,1.93A.71.71,0,0,1,101,294l-1.36-25a2.25,2.25,0,0,1,1-1.9L107,263.4c.61-.35,1.07-.07,1,.63l-1.37,26.77A2.57,2.57,0,0,1,105.55,292.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.88,306.17c-2.14,1.23-3.42-.36-3.42-2.58a8.05,8.05,0,0,1,3.42-6.52c2.13-1.23,3.41.36,3.41,2.58A8.09,8.09,0,0,1,103.88,306.17Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.35,383.47v-26.8l-2.4-2.09v27.09a2.34,2.34,0,0,0,.83,2l2.29,1.75S105.35,383.5,105.35,383.47Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,383.47v-26.8l-2.4-2.09v27.09a2.34,2.34,0,0,0,.84,2l2.29,1.75S105.35,383.5,105.35,383.47Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,356.67v26.8c0,1.82,1.1,2.65,2.46,1.86l56.56-32.65.05,0a5.91,5.91,0,0,0,2.41-4.66V321.17S105.36,356.64,105.36,356.67Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,356.67v26.8c0,1.82,1.1,2.65,2.46,1.86l56.56-32.65.05,0a5.91,5.91,0,0,0,2.41-4.66V321.17S105.36,356.64,105.36,356.67Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,356.67V342.32a.31.31,0,0,1,0-.09,5.9,5.9,0,0,1,2.45-4.61L164.38,305c1.35-.78,2.46,0,2.46,1.85v14.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,303a1.51,1.51,0,0,0-1.62.12l-56.55,32.67a5.18,5.18,0,0,0-2,2.61h0a5.94,5.94,0,0,0-.42,2.08v14.36l2.38,1.8V342.31a5.94,5.94,0,0,1,.42-2.08h0a5.29,5.29,0,0,1,2-2.62L164.38,305l1.46-.2S164.18,303.44,163.6,303Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.68,363.34l-1.09.64a.15.15,0,0,1-.13,0,.14.14,0,0,1,0-.12.41.41,0,0,1,0-.18.44.44,0,0,1,.13-.14l.36-.21v-2.1c0-.12,0-.19-.1-.23a.21.21,0,0,0-.25,0h0a.12.12,0,0,1-.13,0,.13.13,0,0,1,0-.11.41.41,0,0,1,0-.18.36.36,0,0,1,.13-.14h0a.44.44,0,0,1,.73.42v2.1l.36-.21a.12.12,0,0,1,.13,0,.12.12,0,0,1,.06.12.32.32,0,0,1-.06.18A.27.27,0,0,1,111.68,363.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.06,360.71l-.73.42a.85.85,0,0,0-.37.63v.32a.06.06,0,0,0,0,.06,0,0,0,0,0,.06,0l1.55-.89c.05,0,.1,0,.13,0a.11.11,0,0,1,.06.11.32.32,0,0,1-.06.18.35.35,0,0,1-.13.14l-1.82,1a.12.12,0,0,1-.13,0,.12.12,0,0,1-.05-.11V362a1.42,1.42,0,0,1,.21-.72,1.46,1.46,0,0,1,.52-.55l.73-.42a.73.73,0,0,0,.25-.27.63.63,0,0,0,.11-.36v-.42a.22.22,0,0,0-.36-.21l-.73.42a.75.75,0,0,0-.26.27.78.78,0,0,0-.11.36.41.41,0,0,1,0,.18.44.44,0,0,1-.13.14.12.12,0,0,1-.13,0,.14.14,0,0,1-.05-.12,1.48,1.48,0,0,1,.21-.72,1.5,1.5,0,0,1,.52-.54l.73-.42a.46.46,0,0,1,.51-.05.48.48,0,0,1,.22.47v.42a1.64,1.64,0,0,1-.73,1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.7,358.82V359a1.48,1.48,0,0,1-.21.72,1.5,1.5,0,0,1-.52.54l-.73.42a.46.46,0,0,1-.51.05.48.48,0,0,1-.22-.47.38.38,0,0,1,.06-.18.3.3,0,0,1,.12-.13s.1,0,.13,0a.11.11,0,0,1,.06.11.22.22,0,0,0,.36.21l.73-.42a.75.75,0,0,0,.26-.27.7.7,0,0,0,.1-.36V359a.26.26,0,0,0-.1-.24.25.25,0,0,0-.26,0l-.18.1a.13.13,0,0,1-.13,0s0-.06,0-.12a.31.31,0,0,1,0-.18.35.35,0,0,1,.13-.14l.18-.1a.76.76,0,0,0,.36-.63v-.21a.25.25,0,0,0-.1-.24.25.25,0,0,0-.26,0l-.73.42a.84.84,0,0,0-.26.27.7.7,0,0,0-.1.36.32.32,0,0,1-.06.18.35.35,0,0,1-.13.14s-.09,0-.12,0a.12.12,0,0,1-.06-.12,1.39,1.39,0,0,1,.22-.72,1.34,1.34,0,0,1,.51-.54l.73-.42a.51.51,0,0,1,.52-.06.52.52,0,0,1,.21.48v.21a1.06,1.06,0,0,1-.07.38,1.38,1.38,0,0,1-.18.39.39.39,0,0,1,.18.18A.59.59,0,0,1,117.7,358.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,358.16a.32.32,0,0,1-.13.13.13.13,0,0,1-.13,0,.14.14,0,0,1,0-.12V357a1.39,1.39,0,0,1-.36.33l-.73.42a.53.53,0,0,1-.52.05.5.5,0,0,1-.21-.47v-1.06a.41.41,0,0,1,0-.17.36.36,0,0,1,.13-.14.12.12,0,0,1,.13,0s.05.06.05.11v1.06a.25.25,0,0,0,.11.23.27.27,0,0,0,.26,0l.73-.42a.69.69,0,0,0,.25-.28.72.72,0,0,0,.11-.36v-1.05a.49.49,0,0,1,0-.18.4.4,0,0,1,.13-.13s.09,0,.13,0a.11.11,0,0,1,.06.11v3A.38.38,0,0,1,120.56,358.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,353.66a.06.06,0,0,0,0,.06h.06l1-.58a.48.48,0,0,1,.51-.05.5.5,0,0,1,.22.47V354a1.49,1.49,0,0,1-.22.72,1.4,1.4,0,0,1-.51.54l-.73.42a.48.48,0,0,1-.52,0,.5.5,0,0,1-.21-.47.41.41,0,0,1,0-.18.4.4,0,0,1,.13-.13.13.13,0,0,1,.13,0s.05.06.05.12a.22.22,0,0,0,.37.21l.73-.42a.73.73,0,0,0,.25-.27.63.63,0,0,0,.11-.36v-.42a.25.25,0,0,0-.11-.24.24.24,0,0,0-.25,0l-1.1.63a.24.24,0,0,1-.25,0c-.08,0-.11-.12-.11-.24v-1.05a.41.41,0,0,1,0-.18.44.44,0,0,1,.13-.14l1.82-1.05a.12.12,0,0,1,.13,0,.11.11,0,0,1,.06.11.32.32,0,0,1-.06.18.44.44,0,0,1-.13.14l-1.55.89-.06.07a.16.16,0,0,0,0,.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,351.88l.73-.42a.44.44,0,0,1,.73.41v.43a1.41,1.41,0,0,1-.21.71,1.46,1.46,0,0,1-.52.55l-.73.42a.45.45,0,0,1-.73-.42v-1.68a1.34,1.34,0,0,1,.22-.72,1.44,1.44,0,0,1,.51-.55l.73-.42a.53.53,0,0,1,.52-.05.5.5,0,0,1,.21.47.31.31,0,0,1-.05.18.44.44,0,0,1-.13.14.12.12,0,0,1-.13,0,.14.14,0,0,1-.05-.12.23.23,0,0,0-.37-.21l-.73.42a.69.69,0,0,0-.25.28.63.63,0,0,0-.11.36v.53A1.19,1.19,0,0,1,127.9,351.88Zm-.36,1.47a.25.25,0,0,0,.11.24.24.24,0,0,0,.25,0l.73-.42a.85.85,0,0,0,.37-.63v-.42a.22.22,0,0,0-.37-.21l-.73.42a.73.73,0,0,0-.25.27.63.63,0,0,0-.11.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,349.51l-.82,2.26,0,0s0,0,0,0,0,0,0,0,0,0,0,.05l0,.05,0,0,0,0,0,0a.16.16,0,0,1-.13,0s-.05-.05-.05-.13a.86.86,0,0,1,.09-.26l.75-2.11a1.42,1.42,0,0,0,0-.22,1.62,1.62,0,0,0,0-.18v-.07c0-.12,0-.19-.11-.23a.21.21,0,0,0-.25,0l-.37.21-.18.11-.73.42a.12.12,0,0,1-.13,0,.14.14,0,0,1,0-.12.49.49,0,0,1,0-.18.4.4,0,0,1,.13-.13l.73-.42.18-.11.37-.21a.48.48,0,0,1,.51-.05.5.5,0,0,1,.22.47,1.25,1.25,0,0,1,0,.31C132.22,349.37,132.2,349.45,132.19,349.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.19,348.72v.21a1.48,1.48,0,0,1-.21.72,1.36,1.36,0,0,1-.52.54l-.73.42a.46.46,0,0,1-.51.05.49.49,0,0,1-.22-.47V350a1.33,1.33,0,0,1,.07-.38,1.38,1.38,0,0,1,.18-.39.35.35,0,0,1-.18-.18.71.71,0,0,1-.07-.31v-.21a1.49,1.49,0,0,1,.22-.72,1.4,1.4,0,0,1,.51-.54l.73-.42a.48.48,0,0,1,.52-.05.5.5,0,0,1,.21.47v.21a1.15,1.15,0,0,1-.07.39,1.46,1.46,0,0,1-.18.38.39.39,0,0,1,.18.18A.59.59,0,0,1,135.19,348.72Zm-.36-1.26a.22.22,0,0,0-.37-.21l-.73.42a.73.73,0,0,0-.25.27.63.63,0,0,0-.11.36v.21a.25.25,0,0,0,.11.24.24.24,0,0,0,.25,0l.73-.42a.75.75,0,0,0,.26-.27.78.78,0,0,0,.11-.36Zm0,1.47a.27.27,0,0,0-.11-.24.25.25,0,0,0-.26,0l-.73.42a.73.73,0,0,0-.25.27.68.68,0,0,0-.11.36V350c0,.12,0,.2.11.24a.24.24,0,0,0,.25,0l.73-.42a.75.75,0,0,0,.26-.27.72.72,0,0,0,.11-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.29,346.83l-.73.42a.51.51,0,0,1-.51.05.52.52,0,0,1-.22-.47.43.43,0,0,1,.06-.18.44.44,0,0,1,.13-.14.12.12,0,0,1,.13,0,.14.14,0,0,1,0,.12.25.25,0,0,0,.11.23.25.25,0,0,0,.25,0l.73-.42a.71.71,0,0,0,.26-.28.72.72,0,0,0,.11-.36v-.53a1.22,1.22,0,0,1-.37.32l-.73.43a.51.51,0,0,1-.51.05.52.52,0,0,1-.21-.48v-.42a1.41,1.41,0,0,1,.21-.71,1.44,1.44,0,0,1,.51-.55l.73-.42a.45.45,0,0,1,.74.42v1.68a1.46,1.46,0,0,1-.22.72A1.39,1.39,0,0,1,140.29,346.83Zm.37-2.74a.27.27,0,0,0-.11-.24.25.25,0,0,0-.26,0l-.73.42a.73.73,0,0,0-.25.27.78.78,0,0,0-.11.36v.42a.25.25,0,0,0,.11.24.24.24,0,0,0,.25,0l.73-.42a.68.68,0,0,0,.26-.27.72.72,0,0,0,.11-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,345.25l-1.09.63a.12.12,0,0,1-.13,0s-.05-.05-.05-.11a.41.41,0,0,1,.05-.18.36.36,0,0,1,.13-.14l.37-.21v-2.1a.22.22,0,0,0-.36-.22h0a.12.12,0,0,1-.13,0,.14.14,0,0,1-.05-.12.41.41,0,0,1,.05-.18.32.32,0,0,1,.13-.13h0a.51.51,0,0,1,.52-.06.52.52,0,0,1,.21.48V345l.36-.21a.12.12,0,0,1,.13,0,.12.12,0,0,1,.06.12.38.38,0,0,1-.06.18A.33.33,0,0,1,143,345.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,343.88l-.73.42a.48.48,0,0,1-.52.05.5.5,0,0,1-.21-.47V342.2a1.48,1.48,0,0,1,.21-.72,1.36,1.36,0,0,1,.52-.54l.73-.43a.51.51,0,0,1,.51-.05.52.52,0,0,1,.21.48v1.68a1.48,1.48,0,0,1-.21.72A1.4,1.4,0,0,1,145.4,343.88Zm-.73,0,.73-.42a.73.73,0,0,0,.17-.15L144.3,342v1.65a.22.22,0,0,0,.37.21Zm.73-2.94-.73.42a.6.6,0,0,0-.18.15l1.27,1.28v-1.64a.25.25,0,0,0-.11-.24A.24.24,0,0,0,145.4,340.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,342.31l-1.1.63a.15.15,0,0,1-.13,0,.14.14,0,0,1-.05-.12.41.41,0,0,1,.05-.18.32.32,0,0,1,.13-.13l.37-.22v-2.1a.24.24,0,0,0-.11-.23.23.23,0,0,0-.25,0h0a.12.12,0,0,1-.13,0,.12.12,0,0,1-.05-.11.41.41,0,0,1,.05-.18.44.44,0,0,1,.13-.14h0a.44.44,0,0,1,.73.42v2.1l.37-.21a.11.11,0,0,1,.12,0,.12.12,0,0,1,.06.12.32.32,0,0,1-.06.18A.33.33,0,0,1,148.13,342.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.23,339.36l-1.1.63a.11.11,0,0,1-.12,0,.11.11,0,0,1-.06-.11.32.32,0,0,1,.06-.18.28.28,0,0,1,.12-.14l.37-.21v-2.1a.22.22,0,0,0-.36-.22h0a.15.15,0,0,1-.13,0,.14.14,0,0,1-.05-.12.41.41,0,0,1,.05-.18.44.44,0,0,1,.13-.14h0a.53.53,0,0,1,.52-.05.51.51,0,0,1,.21.47v2.11l.37-.21c.05,0,.09,0,.13,0a.14.14,0,0,1,0,.12.41.41,0,0,1,0,.17A.36.36,0,0,1,153.23,339.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6,336.73l-.73.42a.75.75,0,0,0-.26.27.7.7,0,0,0-.1.36v.32s0,0,0,0a.08.08,0,0,0,.07,0l1.55-.9a.12.12,0,0,1,.13,0,.14.14,0,0,1,.05.12.41.41,0,0,1-.05.18.4.4,0,0,1-.13.13l-1.83,1.06a.11.11,0,0,1-.12,0,.12.12,0,0,1-.06-.12V338a1.48,1.48,0,0,1,.21-.72,1.5,1.5,0,0,1,.52-.54l.73-.42a.71.71,0,0,0,.26-.28.72.72,0,0,0,.11-.36v-.42a.25.25,0,0,0-.11-.23.27.27,0,0,0-.26,0l-.73.43a.62.62,0,0,0-.26.27.7.7,0,0,0-.1.36.41.41,0,0,1-.19.31.14.14,0,0,1-.12,0,.12.12,0,0,1-.06-.12,1.45,1.45,0,0,1,.21-.72,1.54,1.54,0,0,1,.52-.55l.73-.42a.52.52,0,0,1,.52-.05.5.5,0,0,1,.21.47v.42a1.42,1.42,0,0,1-.21.72A1.54,1.54,0,0,1,155.6,336.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,336.41l-1.09.64a.15.15,0,0,1-.13,0,.12.12,0,0,1-.06-.12.32.32,0,0,1,.06-.18.35.35,0,0,1,.13-.14l.36-.21v-2.1a.26.26,0,0,0-.1-.24.25.25,0,0,0-.26,0h0c-.06,0-.1,0-.13,0a.11.11,0,0,1-.06-.11.32.32,0,0,1,.06-.18.26.26,0,0,1,.13-.14h0a.48.48,0,0,1,.51-.05.5.5,0,0,1,.21.47v2.1l.37-.21a.12.12,0,0,1,.13,0,.14.14,0,0,1,0,.12.41.41,0,0,1,0,.18A.32.32,0,0,1,158.33,336.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,333.57v.21a1.48,1.48,0,0,1-.21.72,1.43,1.43,0,0,1-.52.54l-.73.43a.51.51,0,0,1-.51,0,.5.5,0,0,1-.22-.48.32.32,0,0,1,.06-.17.28.28,0,0,1,.12-.14.12.12,0,0,1,.13,0,.11.11,0,0,1,.06.11.25.25,0,0,0,.1.24.25.25,0,0,0,.26,0l.73-.42a.62.62,0,0,0,.26-.27.72.72,0,0,0,.11-.36v-.21a.23.23,0,0,0-.37-.21l-.18.11a.12.12,0,0,1-.13,0s0-.06,0-.12a.35.35,0,0,1,0-.18.33.33,0,0,1,.13-.13l.18-.11a.75.75,0,0,0,.26-.27.72.72,0,0,0,.11-.36v-.21a.22.22,0,0,0-.37-.21l-.73.42a.75.75,0,0,0-.26.27.73.73,0,0,0-.1.36.32.32,0,0,1-.06.18.35.35,0,0,1-.13.14.11.11,0,0,1-.12,0,.12.12,0,0,1-.06-.12,1.39,1.39,0,0,1,.22-.72,1.48,1.48,0,0,1,.51-.54l.73-.42a.44.44,0,0,1,.73.42v.21a1.15,1.15,0,0,1-.07.39,1.46,1.46,0,0,1-.18.38.39.39,0,0,1,.18.18A.62.62,0,0,1,161.43,333.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.15,370l-.63.37a.08.08,0,0,1-.08,0s0,0,0-.07a.19.19,0,0,1,0-.1.15.15,0,0,1,.08-.08l.21-.13v-1.22c0-.07,0-.12-.06-.14a.16.16,0,0,0-.15,0h0a.08.08,0,0,1-.08,0s0,0,0-.07a.19.19,0,0,1,0-.1.15.15,0,0,1,.08-.08h0a.28.28,0,0,1,.3,0,.29.29,0,0,1,.12.27v1.23l.21-.12a.08.08,0,0,1,.08,0,.08.08,0,0,1,0,.07.23.23,0,0,1,0,.11A.18.18,0,0,1,111.15,370Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.54,368.51l-.43.24a.46.46,0,0,0-.15.16.42.42,0,0,0-.06.21v.19s0,0,0,0a0,0,0,0,0,0,0l.91-.53h.07a.07.07,0,0,1,0,.07.21.21,0,0,1,0,.1.19.19,0,0,1-.07.08l-1.07.62h-.07s0,0,0-.07v-.36a.84.84,0,0,1,.12-.42.93.93,0,0,1,.3-.32l.43-.25a.34.34,0,0,0,.15-.16.42.42,0,0,0,.06-.21v-.24c0-.07,0-.12-.06-.14a.14.14,0,0,0-.15,0l-.43.24a.39.39,0,0,0-.15.16.42.42,0,0,0-.06.21.19.19,0,0,1,0,.1.15.15,0,0,1-.08.08.06.06,0,0,1-.07,0s0,0,0-.07a.89.89,0,0,1,.42-.73l.43-.25a.28.28,0,0,1,.3,0,.3.3,0,0,1,.13.27v.25a.86.86,0,0,1-.13.42A.85.85,0,0,1,112.54,368.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,367l-.42.25a.39.39,0,0,0-.15.16.35.35,0,0,0-.07.21v.18a.05.05,0,0,0,0,0h0l.9-.52a.08.08,0,0,1,.08,0,.09.09,0,0,1,0,.07.23.23,0,0,1,0,.11.3.3,0,0,1-.08.08l-1.06.61a.08.08,0,0,1-.08,0,.08.08,0,0,1,0-.07v-.37a.9.9,0,0,1,.12-.42,1,1,0,0,1,.31-.32l.42-.24a.46.46,0,0,0,.15-.16.44.44,0,0,0,.07-.21v-.25a.13.13,0,0,0-.07-.13s-.09,0-.15,0l-.42.25a.34.34,0,0,0-.15.16.35.35,0,0,0-.07.21.22.22,0,0,1,0,.1.19.19,0,0,1-.07.08.08.08,0,0,1-.08,0,.08.08,0,0,1,0-.07.84.84,0,0,1,.12-.42.87.87,0,0,1,.31-.32l.42-.24a.31.31,0,0,1,.3,0,.29.29,0,0,1,.13.28v.25a.82.82,0,0,1-.13.42A.75.75,0,0,1,115.09,367Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.22,365.93v.12a.76.76,0,0,1-.13.42.85.85,0,0,1-.3.32l-.42.24a.28.28,0,0,1-.3,0,.27.27,0,0,1-.13-.27.23.23,0,0,1,0-.11.3.3,0,0,1,.08-.08.08.08,0,0,1,.07,0,.07.07,0,0,1,0,.07.14.14,0,0,0,.06.13s.09,0,.15,0l.42-.25a.34.34,0,0,0,.15-.16.35.35,0,0,0,.07-.21v-.12a.13.13,0,0,0-.22-.12l-.1.06a.08.08,0,0,1-.08,0,.08.08,0,0,1,0-.07.26.26,0,0,1,0-.11l.08-.08.1-.06a.34.34,0,0,0,.15-.16.35.35,0,0,0,.07-.21v-.12a.13.13,0,0,0-.22-.12l-.42.24a.46.46,0,0,0-.15.16.42.42,0,0,0-.06.21.25.25,0,0,1,0,.11.27.27,0,0,1-.07.08.12.12,0,0,1-.08,0,.09.09,0,0,1,0-.07.76.76,0,0,1,.13-.42.78.78,0,0,1,.3-.32l.42-.25a.28.28,0,0,1,.3,0,.29.29,0,0,1,.13.28v.12a.66.66,0,0,1,0,.23.91.91,0,0,1-.11.22.23.23,0,0,1,.11.11A.34.34,0,0,1,117.22,365.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,369h0a.08.08,0,0,1-.06-.1l.25-2.26s0-.08.08-.07a.1.1,0,0,1,.07.1l-.26,2.27S113.49,369,113.46,369Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,341.92v7a1.68,1.68,0,0,1-.71,1.35L156.11,354c-.39.23-.71,0-.71-.53v-7a1.72,1.72,0,0,1,.71-1.36c1.73-1,4.61-2.71,6.33-3.71C162.84,341.16,163.15,341.39,163.15,341.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.15 343.42 163.15 343.85 160.66 345.31 160.34 345.49 158.22 346.73 157.9 346.92 155.41 348.37 155.41 347.94 163.15 343.42",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.34 348.91 160.66 348.51 160.66 344.97 160.34 345.36 160.34 348.91",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.9 350.39 158.22 349.99 158.22 346.44 157.9 346.84 157.9 350.39",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.15 346.98 163.15 347.41 155.41 351.93 155.41 351.5 157.9 350.05 158.22 349.86 160.34 348.62 160.66 348.43 163.15 346.98",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.89,357.75l-29.55,17.06a2.24,2.24,0,0,0-.93,1.78v.17c0,.69.42,1,.93.7l29.55-17.06a2.21,2.21,0,0,0,.93-1.78v-.17C141.82,357.77,141.41,357.45,140.89,357.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,345.43a.48.48,0,0,1,.06-.18.29.29,0,0,1,.11-.11l.46-.27a.11.11,0,0,1,.12,0s0,.06,0,.12a3.11,3.11,0,0,1-.12.7,3.4,3.4,0,0,1-.31.75,3.45,3.45,0,0,1-.52.72,3.37,3.37,0,0,1-.77.6,1.8,1.8,0,0,1-.7.25.83.83,0,0,1-.52-.14,1.08,1.08,0,0,1-.33-.48,2.79,2.79,0,0,1-.14-.77c0-.19,0-.41,0-.64s0-.45,0-.65a5,5,0,0,1,.14-.94,4.25,4.25,0,0,1,.33-.86,3.8,3.8,0,0,1,.52-.74,2.92,2.92,0,0,1,.7-.56,1.86,1.86,0,0,1,.77-.28.84.84,0,0,1,.52.11.79.79,0,0,1,.31.4,1.69,1.69,0,0,1,.12.55.39.39,0,0,1,0,.18.28.28,0,0,1-.12.12l-.46.27a.11.11,0,0,1-.11,0s-.06-.05-.06-.11a.68.68,0,0,0-.09-.25.37.37,0,0,0-.17-.16.39.39,0,0,0-.27,0,1.11,1.11,0,0,0-.4.15,1.52,1.52,0,0,0-.39.32,2,2,0,0,0-.28.41,2.29,2.29,0,0,0-.17.46,3,3,0,0,0-.07.5c0,.2,0,.42,0,.65s0,.45,0,.64a1.52,1.52,0,0,0,.07.41.6.6,0,0,0,.17.27.39.39,0,0,0,.28.08.78.78,0,0,0,.39-.13,2,2,0,0,0,.39-.3,1.48,1.48,0,0,0,.28-.35,1.51,1.51,0,0,0,.18-.36A1.59,1.59,0,0,0,112,345.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,340c.47-.28.84-.34,1.09-.19s.37.5.37,1a2.88,2.88,0,0,1-.76,2l.8,1.43a.24.24,0,0,1,0,.08.43.43,0,0,1,0,.14.3.3,0,0,1-.09.1l-.49.28c-.08.05-.13.06-.17,0a.32.32,0,0,1-.08-.09L115,343.4l-.77.45v1.79a.3.3,0,0,1,0,.17.25.25,0,0,1-.1.12l-.47.27a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.12v-5a.41.41,0,0,1,0-.18.26.26,0,0,1,.11-.12Zm-.87,2.92.84-.48a1.79,1.79,0,0,0,.52-.46,1.16,1.16,0,0,0,.2-.7c0-.28-.07-.44-.2-.46a.82.82,0,0,0-.52.16l-.84.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,341.56a.08.08,0,0,1,.1,0,.13.13,0,0,1,0,.12v.55a.28.28,0,0,1,0,.17.34.34,0,0,1-.1.13L117.43,344a.11.11,0,0,1-.11,0,.17.17,0,0,1,0-.12v-5a.34.34,0,0,1,0-.17.29.29,0,0,1,.11-.13l2.48-1.43a.08.08,0,0,1,.11,0,.1.1,0,0,1,0,.11v.55a.35.35,0,0,1,0,.17.36.36,0,0,1-.11.13l-1.86,1.07v1.22l1.73-1a.11.11,0,0,1,.11,0,.14.14,0,0,1,0,.12v.54a.41.41,0,0,1,0,.18.26.26,0,0,1-.11.12l-1.73,1v1.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,335.73a1.86,1.86,0,0,1,.74-.28.77.77,0,0,1,.53.12,1,1,0,0,1,.32.49,2.83,2.83,0,0,1,.13.79,10.84,10.84,0,0,1,0,1.14,4.84,4.84,0,0,1-.13.95,4,4,0,0,1-.32.86,3.29,3.29,0,0,1-.52.72,2.92,2.92,0,0,1-.72.57l-1.45.83a.09.09,0,0,1-.11,0,.17.17,0,0,1-.05-.12v-5a.41.41,0,0,1,.05-.18.32.32,0,0,1,.11-.12Zm.95,1.57a1.19,1.19,0,0,0-.08-.41.6.6,0,0,0-.17-.27.42.42,0,0,0-.3-.07,1,1,0,0,0-.43.16l-.77.44v3.46l.8-.47a1.46,1.46,0,0,0,.41-.32,1.91,1.91,0,0,0,.29-.41,1.88,1.88,0,0,0,.17-.47,2.74,2.74,0,0,0,.08-.5Q123.37,337.86,123.35,337.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,339.58a.09.09,0,0,1-.11,0,.16.16,0,0,1,0-.12v-5a.39.39,0,0,1,0-.18.33.33,0,0,1,.11-.12l.47-.27a.11.11,0,0,1,.11,0,.14.14,0,0,1,0,.12v5a.41.41,0,0,1,0,.17.36.36,0,0,1-.11.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.24,331.78a.11.11,0,0,1,.11,0s0,.06,0,.12v.55a.38.38,0,0,1,0,.17.26.26,0,0,1-.11.12l-1,.6v4.21a.38.38,0,0,1,0,.17.5.5,0,0,1-.11.13l-.47.26a.09.09,0,0,1-.11,0,.17.17,0,0,1,0-.12v-4.21l-1,.6a.11.11,0,0,1-.11,0,.14.14,0,0,1,0-.12v-.55a.41.41,0,0,1,0-.17.26.26,0,0,1,.11-.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.61,332.93a.47.47,0,0,1,.06-.19.38.38,0,0,1,.11-.11l.47-.27a.11.11,0,0,1,.11,0,.12.12,0,0,1,0,.13,3.87,3.87,0,0,1-.11.7,4.17,4.17,0,0,1-.31.74,3.92,3.92,0,0,1-.53.72,3.06,3.06,0,0,1-.76.6,1.69,1.69,0,0,1-.71.25.73.73,0,0,1-.51-.14.87.87,0,0,1-.33-.48,2.7,2.7,0,0,1-.15-.77c0-.19,0-.4,0-.64s0-.45,0-.65a4.75,4.75,0,0,1,.15-.93,3.26,3.26,0,0,1,.33-.87,3.41,3.41,0,0,1,.51-.73,3,3,0,0,1,.71-.57,2,2,0,0,1,.76-.28.89.89,0,0,1,.53.12.75.75,0,0,1,.3.39,1.69,1.69,0,0,1,.12.56.27.27,0,0,1,0,.17.26.26,0,0,1-.11.12l-.47.27a.11.11,0,0,1-.11,0,.15.15,0,0,1-.06-.12.67.67,0,0,0-.08-.25.35.35,0,0,0-.18-.16.39.39,0,0,0-.27,0,1.39,1.39,0,0,0-.39.15,1.76,1.76,0,0,0-.39.32,1.57,1.57,0,0,0-.28.41,1.76,1.76,0,0,0-.18.47,2.76,2.76,0,0,0-.07.49c0,.2,0,.42,0,.65s0,.45,0,.64a1.67,1.67,0,0,0,.07.42.55.55,0,0,0,.18.26.41.41,0,0,0,.28.09.93.93,0,0,0,.39-.14,1.45,1.45,0,0,0,.39-.3,2.26,2.26,0,0,0,.28-.35,2,2,0,0,0,.17-.36A1.19,1.19,0,0,0,133.61,332.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.93,327.34c.06,0,.11,0,.14,0a.26.26,0,0,1,.08.14l1.41,4a.09.09,0,0,1,0,.05.41.41,0,0,1,0,.18.32.32,0,0,1-.11.12l-.41.24c-.08,0-.13,0-.16,0a.18.18,0,0,1-.07-.09l-.25-.71-1.82,1.05-.24,1a.77.77,0,0,1-.07.17.41.41,0,0,1-.16.16l-.41.23a.09.09,0,0,1-.11,0,.17.17,0,0,1-.05-.12.13.13,0,0,1,0-.06l1.41-5.67a1,1,0,0,1,.08-.24.32.32,0,0,1,.14-.14Zm.32,3.19-.64-1.82-.63,2.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73,325.15c.48-.28.85-.34,1.09-.19s.38.49.38,1a3,3,0,0,1-.19,1.07,2.9,2.9,0,0,1-.57.91l.79,1.44a.1.1,0,0,1,0,.07.28.28,0,0,1,0,.15.22.22,0,0,1-.09.1l-.48.28c-.08,0-.14.05-.18,0a.16.16,0,0,1-.07-.09l-.76-1.35-.76.44v1.79a.41.41,0,0,1-.05.18.32.32,0,0,1-.11.12l-.46.27a.11.11,0,0,1-.11,0,.14.14,0,0,1,0-.12v-5a.37.37,0,0,1,0-.17.28.28,0,0,1,.11-.13Zm-.86,2.91.83-.48a1.83,1.83,0,0,0,.53-.45,1.16,1.16,0,0,0,.19-.7c0-.29-.06-.44-.19-.46a.84.84,0,0,0-.53.15l-.83.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,322.93a2,2,0,0,1,.74-.28.72.72,0,0,1,.53.13,1,1,0,0,1,.32.48,2.9,2.9,0,0,1,.13.8,10.65,10.65,0,0,1,0,1.13,5,5,0,0,1-.13,1,4.13,4.13,0,0,1-.32.85,3.29,3.29,0,0,1-.52.72,2.92,2.92,0,0,1-.72.57l-1.45.84a.11.11,0,0,1-.11,0,.15.15,0,0,1,0-.12v-5a.34.34,0,0,1,0-.17.36.36,0,0,1,.11-.13Zm1,1.57a1.67,1.67,0,0,0-.07-.41.54.54,0,0,0-.18-.27.42.42,0,0,0-.3-.07,1,1,0,0,0-.43.16l-.77.44v3.46l.8-.46A1.49,1.49,0,0,0,145,327a1.69,1.69,0,0,0,.29-.41,2.19,2.19,0,0,0,.18-.47,2.74,2.74,0,0,0,.07-.5Q145.57,325.06,145.55,324.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.64,94a.72.72,0,0,0-.28-.64h0l-1.89-1.1h0a.72.72,0,0,0-.71.07l-29.05,16.76-.78-2.61a1,1,0,0,0-.42-.56h0l-1.91-1.1h0a.89.89,0,0,0-.93,0L315.15,112a2.23,2.23,0,0,0-1,1.75V155.4a.72.72,0,0,0,.27.64h0l1.89,1.09h0a.73.73,0,0,0,.7-.09l45.56-26.31a2.24,2.24,0,0,0,1-1.75Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,94a.72.72,0,0,0-.28-.64h0l-1.89-1.1h0a.72.72,0,0,0-.71.07l-29.05,16.76-.78-2.61a1,1,0,0,0-.42-.56h0l-1.91-1.1h0a.89.89,0,0,0-.93,0L315.15,112a2.23,2.23,0,0,0-1,1.75V155.4a.72.72,0,0,0,.27.64h0l1.89,1.09h0a.73.73,0,0,0,.7-.09l45.56-26.31a2.24,2.24,0,0,0,1-1.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,105.87a.9.9,0,0,0-.91,0l-12.49,7.21a2.09,2.09,0,0,0-.71.76l-1.91-1.11a2.2,2.2,0,0,1,.72-.76l12.48-7.2a.89.89,0,0,1,.93,0h0Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.29,93.3a.81.81,0,0,0-.67.1l-29.37,16.95a.89.89,0,0,1-1.35-.54l-.23-.75L360.72,92.3a.94.94,0,0,1,.45-.14.53.53,0,0,1,.26.07h0Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.18,157a.52.52,0,0,0,.1.11l-1.84-1.06h0a.48.48,0,0,1-.17-.2.37.37,0,0,1-.05-.11,1.09,1.09,0,0,1-.05-.33V113.77a.49.49,0,0,1,0-.12,2.17,2.17,0,0,1,0-.25l0-.13c.05-.13.1-.25.16-.37l.06-.13,1.91,1.11a2,2,0,0,0-.3,1V156.5a1.1,1.1,0,0,0,0,.18s0,.06,0,.1l0,.05,0,.06A.27.27,0,0,0,316.18,157Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,105.76a.7.7,0,0,0-.28-.64h0l-1.89-1.1h0a.74.74,0,0,0-.72.07l-29,16.76-.79-2.61a.91.91,0,0,0-.42-.56h0L349,116.55h0a.91.91,0,0,0-.93,0l-12.49,7.21a2.23,2.23,0,0,0-1,1.76v41.62a.72.72,0,0,0,.28.64h0l0,0h0l1.89,1.09h0a.74.74,0,0,0,.69-.08L383,142.55a2.25,2.25,0,0,0,1-1.76Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,105.76a.7.7,0,0,0-.28-.64h0l-1.89-1.1h0a.74.74,0,0,0-.72.07l-29,16.76-.79-2.61a.91.91,0,0,0-.42-.56h0L349,116.55h0a.91.91,0,0,0-.93,0l-12.49,7.21a2.23,2.23,0,0,0-1,1.76v41.62a.72.72,0,0,0,.28.64h0l0,0h0l1.89,1.09h0a.74.74,0,0,0,.69-.08L383,142.55a2.25,2.25,0,0,0,1-1.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.84,117.64a.93.93,0,0,0-.91,0l-12.48,7.21a2.11,2.11,0,0,0-.72.76l-1.9-1.1a2,2,0,0,1,.71-.76L348,116.58a.89.89,0,0,1,.92,0h0Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.68,105.08a.74.74,0,0,0-.66.09l-29.37,17a.89.89,0,0,1-1.36-.54l-.22-.75,29-16.76a.94.94,0,0,1,.45-.13.6.6,0,0,1,.27.06h0Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58,168.78a.33.33,0,0,0,.09.11l-1.84-1.06h0l0,0a.53.53,0,0,1-.17-.19.61.61,0,0,1-.05-.12,1,1,0,0,1-.05-.33V125.42c0-.08,0-.17,0-.25s0-.08,0-.13a2.87,2.87,0,0,1,.15-.37.47.47,0,0,1,.07-.12l1.9,1.1a2.06,2.06,0,0,0-.29,1v41.62a1.09,1.09,0,0,0,0,.18.36.36,0,0,0,0,.1s0,0,0,0l0,.07A.26.26,0,0,0,336.58,168.78Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.43,117.53a.72.72,0,0,0-.28-.64h0l-1.89-1.09h0a.72.72,0,0,0-.71.08L372.46,132.6l-.78-2.61a1,1,0,0,0-.43-.56h0l-1.91-1.1h0a.92.92,0,0,0-.93,0l-12.48,7.2a2.24,2.24,0,0,0-1,1.76v41.62a.71.71,0,0,0,.28.64h0l1.89,1.09h0a.74.74,0,0,0,.69-.08l45.57-26.31a2.24,2.24,0,0,0,1-1.76Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.23,129.41a.91.91,0,0,0-.91.05l-12.48,7.2a2.29,2.29,0,0,0-.72.76l-1.9-1.1a2,2,0,0,1,.72-.76l12.48-7.2a.92.92,0,0,1,.93,0h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.08,116.85a.74.74,0,0,0-.67.1L374,133.89a.88.88,0,0,1-1.35-.54l-.23-.75,29.05-16.75a.84.84,0,0,1,.45-.14.46.46,0,0,1,.26.07h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357,180.56a.47.47,0,0,0,.1.1l-1.84-1.06h0a.7.7,0,0,1-.18-.2l0-.12a.82.82,0,0,1-.05-.33V137.32a.49.49,0,0,1,0-.12,2.34,2.34,0,0,1,0-.26l0-.12a1.8,1.8,0,0,1,.16-.38.67.67,0,0,1,.06-.12l1.9,1.1a2.09,2.09,0,0,0-.29,1v41.63a.91.91,0,0,0,0,.17s0,.07,0,.1l0,.05a.64.64,0,0,0,0,.07A.75.75,0,0,0,357,180.56Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.28,405.7,374.8,367.9a3.79,3.79,0,0,0-3.77,0L257.42,433.5a.84.84,0,0,0,0,1.45l66.1,38.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,397.74v1.47a6.06,6.06,0,0,1-3,5.24l-105.83,61.1a6.09,6.09,0,0,1-6.05,0l-57.68-33.19a6.07,6.07,0,0,1-3-5.24v-2h0v0a.75.75,0,0,0,.38.66l63.35,36.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.4,397.73l-62.75-36.22a3.62,3.62,0,0,0-3.6,0L260.19,424.37a.81.81,0,0,0,0,1.39l63.34,36.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.95 457 289.1 437.48 388.06 380.35 422.08 399.76 322.95 457",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.08 399.76 420.79 400.51 388.06 381.83 290.4 438.23 289.11 437.49 388.06 380.35 422.08 399.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.31 402.7 306.94 403.06 323.52 412.64 353.02 395.61 353.64 395.26 336.43 385.32 306.31 402.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.94 403.06 323.52 412.64 353.02 395.61 336.43 386.03 306.94 403.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,462.33v4a6,6,0,0,0,3-.8l105.83-61.1a6.06,6.06,0,0,0,3-5.24v-1.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Light--inject-10",
    d: "M449.76,321.85,323.53,462.33,205.32,394l-.08,0-1.15-.67c-9.51-6-11.66-20-14.44-43C187,328.16,186.6,303,187,286.17s5.19-30.69,18.39-36.76v0c7-6.43,15.9-10.11,24-13.32,3.22-7.33,3.1-15.65,2.38-26.36-.85-12.3,2-28.79,19.56-37.73s36.71-.39,46.72,9.08L448.3,320.73Z",
    style: {
      fill: "#019E09",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,223.32c10.88.17,16.28,9.18,18.55,25.48,3.12,22.44,6.48,57,6.48,57s20.17,17.35,24.16,21.36,5.67,6.27,4.3,8.92L329.1,352.87c-3.43,1.79-7.49-.8-15.12-5.57s-18.86-13-23.29-16.41c-5.23-4-8.25-6.19-10.69-19s-13.51-67.29-13.51-67.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,346.85c3.14,2.48,7.19,6.62,9.11,8.24s7.51,10.31,10.45,14.87,5,10.17,3.69,14.14-6.34,8.08-7.37,10.52-1.85,5.39-4.09,2.74-3.42-7.51-5.63-11.2-4.84-8.91-7.95-10.75-3.65.08-3.6,1.21c.06,1.32,2,4.75,2,7.88s-1.78,6.23-3.17,6.08-1.88-2.51-3.56-6.3c-1.82-4.1-2.83-4-3.27-8.73s.12-5.95-.37-10.33a17.92,17.92,0,0,0-.82-3.75,6.07,6.07,0,0,0-2.28-3l-1.54-1.07c1.61-7.57,6.21-12.38,14.12-14.14C350.29,343.24,351.45,344.38,354.6,346.85Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,380.35h0l0-.06Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88,335.57s-4.43-.89-9.86,6-3.16,10.47-3.16,10.47L338,358.68c2.46-7.1,8.89-13.6,14.43-13.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.71,355.09c-1.92-1.62-6-5.76-9.11-8.24-.94-.73-1.69-1.34-2.29-1.85h.13l-10.92-8.9c1.37-2.65-.3-4.91-4.3-8.92s-24.16-21.36-24.16-21.36-3.36-34.57-6.48-57c-2.24-16.05-7.51-25-18.06-25.45h0c7.36.76,13.72,9.62,15.72,21.27s5.87,59.71,5.87,59.71a14.73,14.73,0,0,0-6.72,4.85s5.84-3.53,7.75-2.43,16.85,14.76,21,17.8,10,7.8,7.8,11.57c0,0-.75,1.2,4.28,4.85s13.55,10.92,19.2,15.73a41.37,41.37,0,0,1,6.59,6.86C367.49,359.8,364.89,356.09,363.71,355.09Z",
    style: {
      fill: "#019E09"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-10",
    d: "M229.39,236.11c-9.88,3.91-21,8.49-28.22,17.87s-8.4,78,.13,103.2,30.1,39.22,30.1,39.22l71.34-41.19s-10-19.75-9.05-35.36,5.93-94.5-8.15-96C265.28,223.24,229.39,236.11,229.39,236.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.69,319.85c.54-8.83,2.37-38,1.3-61.83,0,0-.71,25.9-1.71,38.42s-3.7,25.53.86,42.34a78,78,0,0,0,6.73,17.52l1.87-1.09S292.73,335.46,293.69,319.85Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Skull--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.44,340.25a1.16,1.16,0,0,1,.86-.37,3.14,3.14,0,0,0,2.46-1.19l16.21-17a4.73,4.73,0,0,0,1.11-2.57v0c.18-1.27.94-2.43,1.7-2.58.45-.08.78.35.86,1s.32.85.69.8.73.19.84.74a4,4,0,0,1-1,3.22,1.24,1.24,0,0,1-.77.39,4.73,4.73,0,0,0-3.14,1.64l-15.48,16.25a5.55,5.55,0,0,0-1.3,3v0c-.18,1.28-1,2.43-1.71,2.55-.45.08-.77-.37-.84-1.05s-.32-.87-.68-.82-.73-.22-.83-.77A4,4,0,0,1,257.44,340.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.15,307.31c0-1.56.91-2.72.91-7.31s-2.9-7.71-8.77-4.32-8.77,9.86-8.77,14.44.92,4.7.92,6.26-1.68,3.44-.92,5.21,2.15-.08,3,.19,1,1.09,1,3.11c0,0,1.29,1.36,4.78-.65a12.13,12.13,0,0,0,4.79-4.88,6.82,6.82,0,0,1,1-4.31c.8-1.2,2.2-.95,2.95-3.58S277.15,308.87,277.15,307.31Zm-13.09,10.5c-1.35-.1-1.47-2.39-1.09-3.66a4.68,4.68,0,0,1,2.59-2.9c1.81-.74,2.77.87,2.13,2.91S265,317.88,264.06,317.81Zm6.66.84c-.39.53-1.15.62-1.43-.43-.28,1.37-1,2.16-1.42,2.07s-.3-.77.05-2,1.37-3.56,1.37-3.56a10,10,0,0,1,1.38,2C271,317.54,271.1,318.11,270.72,318.65Zm3.81-6.88c-.94,1.15-3,1.83-3.63.53s.32-4,2.13-5.36c1.16-.87,2.22-.95,2.58-.09A5.76,5.76,0,0,1,274.53,311.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,326.57a1.6,1.6,0,0,0-.85.62,4,4,0,0,1-2.47,1.65l-16.21,1.7c-.57.06-1-.46-1.11-1.29h0c-.17-1.08-.94-1.36-1.69-.63a3.44,3.44,0,0,0-.86,2,2.8,2.8,0,0,1-.7,1.6,3.1,3.1,0,0,0-.83,1.71c-.21,1.27.24,2.2,1,2.05a1.46,1.46,0,0,0,.77-.5,5.42,5.42,0,0,1,3.15-2l15.48-1.63c.66-.07,1.13.52,1.29,1.47v0c.19,1.06,1,1.32,1.71.57a3.49,3.49,0,0,0,.85-2,2.72,2.72,0,0,1,.68-1.6,3.23,3.23,0,0,0,.82-1.72C282.37,327.31,281.9,326.4,281.14,326.57Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239,264.67c13.85,12.94,31.55,14.78,31.55,14.78s-5.87-1.93-17.25-12.74c-8-7.6-11.82-24.63-13.38-34l-1.38.43-.46.14-1,.32-.38.12-1.21.39-.37.13-.85.27-.33.11-1,.32-.32.11-.62.21-.27.09-.7.24-.19.06-.44.15-.18.07-.4.14-.08,0-.21.08-.05,0-.08,0c-1.08.42-2.18.86-3.28,1.31C226.51,242.66,228.62,255,239,264.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,279.45c4.6-4,5.66-16.72,11.85-22.33s25.72-20.5,30.56-31-9.23-12.79-25-7.08-28.89,17.15-30.44,30.6S259.89,275.4,270.52,279.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,218.05c-.7,9.36-1.93,19.13-5.54,27.87-2.72,6.62-5.73,12.15-12.13,11.37a37.46,37.46,0,0,1-10.69-3.05l-2.28,9.59a72.1,72.1,0,0,1-.08,15.62c-5.27-2-11.35-6.59-16.39-11.68-.59-.6-1.18-1.2-1.74-1.81-3.64-3.95-6.55-8-7.9-11.27,0,0,.4-5.39.75-10.31.28-3.74.93-7.36.13-11-.87-4.1-2.47-8-3.37-12.07-.19-.89-.35-1.79-.48-2.69a34.88,34.88,0,0,1,8.41-28c7.43-8.1,19.3-12,30-9.41a28.91,28.91,0,0,1,15,9.48c3.07,3.63,4.5,7.55,5.95,12C302.48,207.43,301.62,213,301.24,218.05Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,233.94c-1.69,10.69-6.44,19.25-10.15,21.67s-11.41.11-11.76,0a36.12,36.12,0,0,0,7.21,1.68c6.4.78,9.41-4.75,12.13-11.37,3.61-8.74,4.84-18.51,5.54-27.87.28-3.77.84-7.84.44-11.68L298.27,205C299.8,216.63,300,223.25,298.27,233.94Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.6,263.83a72.1,72.1,0,0,1-.08,15.62c-5.27-2-11.35-6.59-16.39-11.68-.59-.6-1.18-1.2-1.74-1.81-3.64-3.95-6.55-8-7.9-11.27,0,0,.4-5.39.75-10.31.28-3.74.93-7.36.13-11-.05-.26-.12-.52-.17-.77l1.51-3.61a47.81,47.81,0,0,0,10,15.53c3.94,4.26,8.73,6.29,16.18,9.75Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.89 226.57 291.16 227.77 289.85 244.63 298.99 243.15 291.89 226.57",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,229.18a1.19,1.19,0,0,0-2,.43c-.59,2.11-1,4.84-2.86,6.48-2.56,2.26-8.71,2.63-11.52,1.25-2.64-1.29-3-7.39-4.57-8.34-.64-.4-1.21-.27-1.45-1.73-.21-1.29.43-1.54,1.37-1.71,3.34-.61,14.57-2.53,16.51-2.21s1.42,3.09,3.25,3c1.61-.09,1.31-3,3.18-3.59a58.74,58.74,0,0,1,10.22-1.11c.87,0,1.52.09,1.41,1.36-.14,1.71-.88,1.71-1.34,1.83-.72.17-1.26,5.89-2.27,7.5-1.56,2.5-7.71,2.11-7.71,2.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,236.59c2.47-.25,4.4-.93,5.26-2.08,1.28-1.72,1.89-5.72,1.71-7.2s-.57-2.83-4.74-2.44-7.12.55-8.71,1.7-1.07,3.46-.55,5.18a9.12,9.12,0,0,0,2.16,4.09C278.17,236.47,280.15,236.8,282.27,236.59Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.27,236.59c2.47-.25,4.4-.93,5.26-2.08,1.28-1.72,1.89-5.72,1.71-7.2s-.57-2.83-4.74-2.44-7.12.55-8.71,1.7-1.07,3.46-.55,5.18a9.12,9.12,0,0,0,2.16,4.09C278.17,236.47,280.15,236.8,282.27,236.59Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,224.11c-1.46.55-2.07,2.64-1.65,4.72s1.15,3.78,1.67,4.08c.92.54,4.29,0,5.35-.79s2-5.46,2.12-6.66c.13-1.47-.31-2.18-2-2.08A27.55,27.55,0,0,0,295.88,224.11Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,224.11c-1.46.55-2.07,2.64-1.65,4.72s1.15,3.78,1.67,4.08c.92.54,4.29,0,5.35-.79s2-5.46,2.12-6.66c.13-1.47-.31-2.18-2-2.08A27.55,27.55,0,0,0,295.88,224.11Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,279.45c-8-3.09-14.47-21.68-7.67-35.79s28-22.88,40.74-23.24,9.87,4.38,9.34,5.72c0,0,4.33-3.86,2.22-15.11-2.16-11.52-7.09-20.45-17.1-29.93s-29.21-18-46.72-9.08-20.4,25.43-19.57,37.73c.73,10.7.85,19-2.37,26.36,0,0-2,9.58,8.9,23.34S270.52,279.45,270.52,279.45Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290,414.33s1.34.53,3.5,1.14c1.94.55,3.74,1.88,8.34,2.88,5.45,1.19,12.09-1.3,16.69-1.92s12.6.86,17,2.24,9-5.64,11.24-5,5.79-1.43,1.53-5-10.41-8.52-15.33-9.71a28.82,28.82,0,0,0-3.46-.77,37.25,37.25,0,0,0,4.85-1.39,8.71,8.71,0,0,0,3.93-3.1c.37-.57.6-1.45,0-1.84a1.15,1.15,0,0,0-.7-.2c-3.6.19-6.48-.13-9.76-.1a13.71,13.71,0,0,0-4.39.45c-1.31.47-2.61,1-3.89,1.53-5.79,2.56-11.07,4.86-19.67,3.59l-3.58-.94c-1.11,0-3.4,2.56-5,7.11C288.75,410.44,290,414.33,290,414.33Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.28,395.8a16.23,16.23,0,0,0-6.45,1.59,36.15,36.15,0,0,1,8.65.78,37.25,37.25,0,0,0,4.85-1.39,9.08,9.08,0,0,0,3.58-2.62C335.47,396.13,330.41,395.85,327.28,395.8Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.36,249.42c6.1.68,16,16,18.14,32.71,2.23,17.54,5.74,77.77,5.74,77.77s25.36,12.41,35.62,17.17,18.8,8.8,19.17,13.2c-6.09,2.77-8.2,11.8-8.37,20.65-3.87,5.43-50.53-9.32-68.21-16-12.42-4.7-14.72-19.2-17.8-44.64C187,328.16,186.6,303,187,286.18S192.16,255.48,205.36,249.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,390.27l13.4,6.2c-4.67,1.31-7.73,10.94-6.64,18.25l-15.13-3.8s-3.16-4.22.95-12.71S284,390.27,284,390.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.73,395.15h0a28.53,28.53,0,0,1-15.86,2l-2.45-.64-13.4-6.2c-.37-4.4-8.92-8.43-19.17-13.2s-35.62-17.17-35.62-17.17-3.51-60.23-5.74-77.77a60.93,60.93,0,0,0-4.36-15.91l-3-6.13c4,8.67,6.08,30.17,8.55,62s2.08,38.27,2.08,38.27a58.77,58.77,0,0,0-7.93,8.24s8.39-6.83,12.59-5.25,36,16.14,41.85,19.47,8.51,5.9,8,8.77c0,0,11.52,4.57,15,6.18S307.76,400.14,315.73,395.15Z",
    style: {
      fill: "#019E09"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325.23,463.22a7.19,7.19,0,0,0,6.18-.48l105.36-60.83a7.17,7.17,0,0,0,3.48-5l11.54-68.78a7.91,7.91,0,0,0,.09-1.18,7.13,7.13,0,0,0-2.12-5.09L340.27,385.07a5.31,5.31,0,0,0-2.57,3.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,462.33l.72.41a8.09,8.09,0,0,0,1,.48l12.47-74.44a5.31,5.31,0,0,1,2.57-3.71l109.49-63.22a7.07,7.07,0,0,0-1.46-1.12L338.59,384.07a5.34,5.34,0,0,0-2.58,3.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,386.47l-1.7-1a5.32,5.32,0,0,0-1,2.29l-12.48,74.55.72.41a8.09,8.09,0,0,0,1,.48l12.47-74.44A5.3,5.3,0,0,1,338.72,386.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,399.72c.77-4.6,5.53-10.72,10.62-13.66s8.6-1.59,7.82,3-5.52,10.73-10.62,13.67S383.8,404.33,384.57,399.72Z",
    style: {
      fill: "#019E09"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--virus-box--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.81,126.46l-11,6.37L260.67,144a1.47,1.47,0,0,0,.69.81c.77.42,4.15,2.4,4.43,2.56a1.47,1.47,0,0,0,2.19-.91l4.31-17.45Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,126.46l-11,6.37L260.67,144a1.47,1.47,0,0,0,.69.81c.77.42,4.15,2.4,4.43,2.56a1.47,1.47,0,0,0,2.19-.91l4.31-17.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,135.42l3.89,11.21a1.47,1.47,0,0,0,2.82-.13l4.31-17.45Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.46,75.45A6.94,6.94,0,0,0,285.32,70l-.53-.31a7,7,0,0,0-6.28,0L239.28,92.39a7,7,0,0,0-3.14,5.44V141a7,7,0,0,0,3.14,5.44l.52.3a7,7,0,0,0,6.29,0l39.23-22.69a7,7,0,0,0,3.14-5.44Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,141a7,7,0,0,0,3.14,5.44l.52.3a7.06,7.06,0,0,0,5.75.25c-1.48.56-2.6-.27-2.6-2.06V101.76a6.37,6.37,0,0,1,.92-3.09l-6.81-3.93a6.37,6.37,0,0,0-.92,3.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35,74.55c-.36-1.33-1.58-1.75-3-.92l-39.23,22.7a6.12,6.12,0,0,0-2.22,2.34l-6.8-3.93a6.4,6.4,0,0,1,2.21-2.34L278.5,69.71a7,7,0,0,1,6.29,0l.53.3A6.91,6.91,0,0,1,288.35,74.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Virus--inject-10",
    d: "M281.23,106.8l-1-7.5a.91.91,0,0,0-.56-.72.8.8,0,0,0-.34-.07.9.9,0,0,0-.57.2l-2.53,2a11.58,11.58,0,0,0-1.52-3.58v0h0v0L276,94l1.69-5.89a.89.89,0,0,0-.62-1.11.73.73,0,0,0-.25,0,.91.91,0,0,0-.87.66l-1.64,5.72-.95,2.27a6.61,6.61,0,0,0-.86-.64,5.71,5.71,0,0,0-2.88-.86l1.53-5.93a.91.91,0,0,0-.65-1.1.85.85,0,0,0-.23,0,.9.9,0,0,0-.87.68l-1.7,6.6a8.87,8.87,0,0,0-2,.8,10.69,10.69,0,0,0-1.41.89l-1.09-4a.91.91,0,0,0-.87-.67,1,1,0,0,0-.24,0,.91.91,0,0,0-.64,1.11l1.31,4.84a23.84,23.84,0,0,0-4.63,6.36l-.41-.64-1.29-4a.91.91,0,0,0-.86-.63.87.87,0,0,0-.28,0,.91.91,0,0,0-.59,1.13l1.37,4.26,1.14,1.76a33.29,33.29,0,0,0-2.1,6.61.64.64,0,0,0-.2,0l-3.15.83a.9.9,0,0,0-.66.72l-1.52,8.86a.92.92,0,0,0,.74,1h.16a.91.91,0,0,0,.89-.75l1.42-8.29,2-.52a30.28,30.28,0,0,0-.3,3.28,19.93,19.93,0,0,0,.81,6.61.87.87,0,0,0-.23.2l-2.92,3.53a.9.9,0,0,0-.12,1l2.82,5.7a.9.9,0,0,0,.81.51,1,1,0,0,0,.4-.1.9.9,0,0,0,.41-1.21l-2.56-5.18,2.15-2.59a7.64,7.64,0,0,0,2.69,3,5.77,5.77,0,0,0,3.09.87,7.91,7.91,0,0,0,3.73-1l.05,0h0c4-2.17,7.55-7.44,9.53-13.43l.11,0,2.21.36-2.9,7.94a.9.9,0,0,0,.54,1.16.81.81,0,0,0,.31.06.91.91,0,0,0,.85-.6l3.27-9a.9.9,0,0,0-.7-1.2l-3.17-.52a30.67,30.67,0,0,0,1.09-7.06,23.85,23.85,0,0,0-.17-3.75l.08,0,1.95-1.57.79,5.91a.91.91,0,0,0,.9.79h.12a.91.91,0,0,0,.6-.35A.94.94,0,0,0,281.23,106.8Zm-14.67-10a6.09,6.09,0,0,1,2.88-.81,4,4,0,0,1,2.13.6,5,5,0,0,1,1,.85c-1.85,3.67-4.49,6.66-7.19,8.11a6.93,6.93,0,0,1-3.23.92,4,4,0,0,1-2.81-1.09C261.22,101.44,263.79,98.25,266.56,96.76ZM256.3,117.49a30.92,30.92,0,0,1,2.28-10.41,5.74,5.74,0,0,0,3.54,1.18,7.87,7.87,0,0,0,2.74-.53l-.61,19.68a5.82,5.82,0,0,1-2.41.58,4,4,0,0,1-2.14-.6C257.43,126,256.15,122.28,256.3,117.49Zm9.8,8.79.6-19.43a20.3,20.3,0,0,0,7-7.73,16.07,16.07,0,0,1,1.25,7.33C274.73,114.24,270.87,122.67,266.1,126.28Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--padlock--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--padlock--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.25,227.81a3.39,3.39,0,0,0-2-2.78l-3.91-2.26a10.65,10.65,0,0,0-9.62,0l-35.48,20.49a3.39,3.39,0,0,0-2,2.78h0v46.87h0a3.37,3.37,0,0,0,2,2.78l3.91,2.26a10.59,10.59,0,0,0,9.62,0l35.48-20.49a3.38,3.38,0,0,0,2-2.77h0V227.81Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.15,251.07l-3.91-2.26c-2.66-1.53-2.66-4,0-5.55l35.48-20.49a10.65,10.65,0,0,1,9.62,0l3.91,2.26c2.66,1.53,2.66,4,0,5.55l-35.48,20.49A10.65,10.65,0,0,1,386.15,251.07Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,230c0,1.22-1.72,2.2-3.84,2.2s-3.83-1-3.83-2.2,1.71-2.21,3.83-2.21S423.66,228.81,423.66,230Z",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,230c0,1.22-1.72,2.2-3.84,2.2s-3.83-1-3.83-2.2,1.71-2.21,3.83-2.21S423.66,228.81,423.66,230Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.82,230a4.83,4.83,0,0,0-3.3,1.1,5.52,5.52,0,0,0,6.61,0A4.86,4.86,0,0,0,419.82,230Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,252.22V299.1a9.91,9.91,0,0,1-4.81-1.14l-3.92-2.27a3.33,3.33,0,0,1-2-2.79V246a3.35,3.35,0,0,0,2,2.78l3.92,2.27A9.91,9.91,0,0,0,391,252.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.79,275.41l-8.48,4.89L409.63,265c-1-.53-1.66-1.85-1.66-3.74,0-3.38,2-7.3,4.58-8.76s4.58.09,4.58,3.46a11.55,11.55,0,0,1-1.65,5.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.79 275.41 409.11 270.98 408.31 280.3 416.79 275.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.55,252.47a10,10,0,0,0-3.91,5.18l6.84,4h0a11.55,11.55,0,0,0,1.65-5.67C417.13,252.56,415.08,251,412.55,252.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,211.62h0V210.1c0-5.8-2.2-10.4-6-12.61-3.65-2.1-8.17-1.82-12.72.81-8.35,4.82-14.9,16.59-14.9,26.79v18.85h0a1.9,1.9,0,0,0,1.13,1.56,6,6,0,0,0,5.42,0,1.88,1.88,0,0,0,1.12-1.56h0V225.09c0-7.46,5.07-16.69,11.07-20.15,2-1.18,3.88-1.47,5-.8,1.37.79,2.19,3,2.19,6v1.51h0a1.89,1.89,0,0,0,1.12,1.55,6,6,0,0,0,5.42,0,1.93,1.93,0,0,0,1.13-1.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.43,196.74c-.41.19-.81.41-1.22.64-8.35,4.83-14.9,16.61-14.9,26.81V243a1.88,1.88,0,0,0,1.13,1.57,5.82,5.82,0,0,0,3.58.59,2.25,2.25,0,0,1-.45.32,6,6,0,0,1-5.42,0,1.88,1.88,0,0,1-1.13-1.56V225.09c0-10.2,6.55-22,14.9-26.8A17.28,17.28,0,0,1,408.43,196.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,210.11v1.51a1.68,1.68,0,0,1-.67,1.23,2.87,2.87,0,0,1-.46.33,6.08,6.08,0,0,1-5.42,0,1.94,1.94,0,0,1-1.13-1.56v-1.51c0-3-.81-5.19-2.17-6a3.48,3.48,0,0,0-2.57-.2,8.69,8.69,0,0,0-2.48,1c-6,3.46-11.07,12.69-11.07,20.14v18.85a1.63,1.63,0,0,1-.67,1.24,5.82,5.82,0,0,1-3.58-.59,1.88,1.88,0,0,1-1.13-1.57V224.19c0-10.2,6.55-22,14.9-26.81.41-.23.81-.45,1.22-.64a11.19,11.19,0,0,1,9.21.75C421.46,199.7,423.66,204.3,423.66,210.11Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bolt--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "450.87 207.37 441.87 211.63 442.63 214.73 437.02 215.03 437.99 217.67 431.45 219.31 442.21 220.47 441.04 217.56 448.21 218.27 447 214 453.59 214.27 450.87 207.37",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.87 207.37 441.87 211.63 442.63 214.73 437.02 215.03 437.99 217.67 431.45 219.31 442.21 220.47 441.04 217.56 448.21 218.27 447 214 453.59 214.27 450.87 207.37",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.35 209.95 432.54 212.59 428.74 218.16 436.35 212.74 434.74 210.49 440.57 206.24 436.15 202.75 430.35 209.95",
    style: {
      fill: "#019E09"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.35 209.95 432.54 212.59 428.74 218.16 436.35 212.74 434.74 210.49 440.57 206.24 436.15 202.75 430.35 209.95",
    style: {
      opacity: 0.5
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSection);
export default __webpack_public_path__ + "static/media/aboutSection.e15ef24d0854a748df035ca9e0908719.svg";
export { ForwardRef as ReactComponent };